import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "message", "messageContent"]

  connect() {
    console.log("Webhook event settings controller connected")
  }

  async enableAll() {
    this.showLoading(true)
    
    try {
      const response = await fetch("/webhook_event_preferences/enable_all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        // Reload the page to show updated settings
        window.location.reload()
      } else {
        const error = await response.json()
        this.showMessage(`Failed to enable all webhook events: ${error.message || "Unknown error"}`, "error")
      }
    } catch (error) {
      console.error("Error enabling all webhook events:", error)
      this.showMessage("Failed to enable all webhook events", "error")
    } finally {
      this.showLoading(false)
    }
  }

  async disableAll() {
    this.showLoading(true)
    
    try {
      const response = await fetch("/webhook_event_preferences/disable_all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        // Reload the page to show updated settings
        window.location.reload()
      } else {
        const error = await response.json()
        this.showMessage(`Failed to disable all webhook events: ${error.message || "Unknown error"}`, "error")
      }
    } catch (error) {
      console.error("Error disabling all webhook events:", error)
      this.showMessage("Failed to disable all webhook events", "error")
    } finally {
      this.showLoading(false)
    }
  }

  showLoading(show) {
    if (show) {
      this.loadingTarget.classList.remove("hidden")
    } else {
      this.loadingTarget.classList.add("hidden")
    }
  }

  showMessage(message, type) {
    this.messageContentTarget.innerHTML = `
      <div class="flex items-center space-x-2">
        <div class="w-4 h-4 ${type === "success" ? "text-green-500" : "text-red-500"}">
          ${type === "success" ? "✓" : "✗"}
        </div>
        <span class="text-sm ${type === "success" ? "text-green-700" : "text-red-700"}">${message}</span>
      </div>
    `
    this.messageTarget.classList.remove("hidden")
    
    // Hide message after 5 seconds
    setTimeout(() => {
      this.messageTarget.classList.add("hidden")
    }, 5000)
  }
}
